import { IntroCandidateemailComponent } from './../intro-candidateemail/intro-candidateemail.component';
import { CandidateService } from 'src/app/_services/candidate.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TransactionService } from 'src/app/_services/transaction.service';
import { TalentpoolService } from './../../_services/talentpool.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { SearchtoolboxService } from "./../../_services/searchtoolbox.service";
import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalService } from 'src/app/_services/global.service';
import * as __ from 'lodash';
import { environment } from 'src/environments/environment';
import { CandidateEmailComponent } from 'src/app/candidate/candidate-email/candidate-email.component';
import { AddToTalentpoolComponent } from 'src/app/talentpool/add-to-talentpool/add-to-talentpool.component';
import moment from 'moment';
import { AbstractControl, UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { PersonSearchService } from 'src/app/_services/person-search.service';


declare const clevertap;
const devFrontendUrl = environment.frontendurl
@Component({
    selector: "app-searchtoolbox-v3",
    templateUrl: "./searchtoolbox-v3.component.html",
    styleUrls: ["./searchtoolbox-v3.component.scss"],
    standalone: false
})
export class SearchtoolboxV3Component implements OnInit {
  viewMoreClicked: number = 1;
  jobtitle: string;
  mandatoryskill: string;
  preferredskill: string;
  location: String;
  company: String;
  excludekeyword: string;
  isCurrentJobTitle: Boolean = false;
  isCurrentCompany: Boolean = false;
  isOpentoWork: Boolean = false;
  additionfields: Boolean
  mappings: Array<any> = [];
  startindex: number = 100;
  starthistory: any = 0;
  searchToolboxHistory: any[] = [];
  disablebutton: Boolean = true;
  modalDismissed: Boolean = false;
  @ViewChild('historymodal') historymodal: TemplateRef<any>;
  @ViewChild('grabModal') grabModal: TemplateRef<any>;
  @ViewChild('noCreditsJDParse') noCreditsJDParse: TemplateRef<any>;
  @ViewChild('noCreditsGrab') noCreditsGrab: TemplateRef<any>;
  @ViewChild('requestCredit') requestCredit: TemplateRef<any>;
  @ViewChild('GrabInProgress') GrabInProgress: TemplateRef<any>;
  @ViewChild('GrabStarted') GrabStarted: TemplateRef<any>;
  @ViewChild('noCreditsCE') noCreditsCE: TemplateRef<any>;
  @ViewChild('extractToTalentpool') extractToTalentpool: TemplateRef<any>;
  @ViewChild('extractingProfile') extractingProfile: TemplateRef<any>;
  @ViewChild('premiumUserError') premiumUserError: TemplateRef<any>;

  talentpool_form: UntypedFormGroup;
  profileurlsarray: any = []
  booleanquery: any;
  jdMode: boolean;
  platformlist: any = [{
    platforname: 'General',
  }, {
    apiname: 'linkedInSearch',
    platforname: 'LinkedIn',
    classname: 'fab mr-1 fa-linkedin-square'
  }, {
    apiname: 'twitterSearch',
    platforname: 'Twitter',
    classname: 'fa-brands mr-1 fa-square-x-twitter'
  }, {
    apiname: 'xingSearch',
    platforname: 'Xing',
    classname: 'fab mr-1 fa-xing'
  }, {
    platforname: 'Technical',
  }, {
    apiname: 'githubSearch',
    platforname: 'GitHub',
    classname: 'fab mr-1 fa-github'
  }, {
    apiname: 'stackOverflowSearch',
    platforname: 'Stack Overflow',
    classname: 'fab mr-1 fa-stack-overflow'
  }, {
    apiname: 'kaggleSearch',
    platforname: 'Kaggle',
    classname: 'fab mr-1 fa-kaggle'
  }, {
    platforname: 'Creative',
  }, {
    apiname: 'behanceSearch',
    platforname: 'Behance',
    classname: 'fab mr-1 fa-behance'
  }, {
    apiname: 'dribbbleSearch',
    platforname: 'Dribbble',
    classname: 'fab mr-1 fa-dribbble'
  }];

  platformselected: any = 'LinkedIn'
  categorySelected: any = 'All';
  searchResults: any[] = [];
  searchResultNextPage: any;
  totalSearchResultsCount: number = 0;
  pageNumber: number = 1;
  refinementTags: any[] = [];
  totalcandidatesForGrabString: string;
  talentpoolFound: any;
  totalcandidatesForGrab: any;
  ErrorMessage: string;
  noTalentpoolError: any;
  errorMessage: any;
  booleanquery_to_display: any;
  talentpoolname: any;
  talentpoolslist: any;
  successMessage: string;
  searchQuerySentToCSE: any;
  jdParseError: boolean;
  fieldsRequired: boolean;
  Boolean_fieldsRequired: boolean;
  subscriptiondetails: any = {};
  enrichResult: boolean;
  totalCandidatetoSendEmail: any[];
  totalCandidateforTalentpool: any[];
  totalCandidatetoRevealContacts: any[];
  editBooleanQuery : boolean
  isExtensioninstalled: any;
  globalClevertapEvents: any = {}
  talentpoolAndCandidateData: any;
  bulkGrabbingDonePreviously: any;
  isCategoryChanged: boolean;
  showLoading: boolean;
  getResultForLinkedin: any[] = [];
  totalClicked: number = 1;
  maxPageSize: number = 0;
  isNextPagePresent: boolean = true;
  currentCandidate: any;
  showCandidate: boolean = false;
  addToTalentpoolSpinner: boolean = false;
  tabType: any = 'profileTab'
  isLoading: boolean = false;

  constructor(private searchtoolbox: SearchtoolboxService,
    private _localstorageservice: LocalStorageService,
    private modalService: NgbModal,
    private talentpoolservice: TalentpoolService,
    private transactionservice: TransactionService,
    private router: Router,
    private candidateservice : CandidateService,
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private personSearchService: PersonSearchService
    ) { }
  filteredJobTitleOptions: Array<any> = [];
  filteredMandatorySkillsOptions: Array<any> = [];
  filteredPreferredSkillsOptions: Array<any> = [];
  filteredLocationsOptions: Array<any> = [];
  filteredCompaniesOptions: Array<any> = [];

  jobtitles: any[] = [];
  mandatoryskills: any[] = [];
  preferredskills: any[] = [];
  locations: any[] = [];
  companies: any[] = [];
  excludekeywords: any[] = [];
  synonyms: any[] = []
  boolean_synonyms: any[] = []
  //for jd parsin
  incorrectFileFormat: boolean = false;
  specialCharaterError: boolean = false;
  uploadedFilename: string;
  isUploadedFileCorrect: boolean = false;
  showJDNotAddedError: boolean = false;
  enteredJobDescription: string;
  uploadedFile: any = undefined;
  disableManualJDInput: boolean = false;
  fileSizeLimitExceeded: boolean = false;

  tabActive: any = 'bbuilder'
  showSearchResult: boolean = false

  candidatetoBeGrabbed: any[] = []
  selected: boolean

  recommendedjobtitle: any[] = []
  recommendedskills: any[] = []
  deselectedJobTitlesArray: any[] = [];
  deselectedSkillsArray: any[] = [];

  searchCalled: Boolean = false;

  ngOnInit() {
    this.gethistory()
    this.fetchcredits()
    let data = this.candidateservice.getSimilarCandidateData()
    if (data && (data.jobtitles || data.locations || data.preferredskills)) {
      this.repeatSearch(data, 'similarcandidate')
      this.candidateservice.passSimilarCandidateData('')
    }
    this.searchtoolbox.getmappings().subscribe((res: any) => {
      if (res.status == 'success') {
        this.mappings = res.data
      }
      this.sendMessagetoChrome()
    })

    this.talentpool_form = this.fb.group({
      talentpoolname: ['', [Validators.required, noWhitespaceValidator , Validators.pattern(/^(?!.*<[^>]+>).*/i)]],
      talentpooldescription: ['', [Validators.required, noWhitespaceValidator , ValidateHTMLTAGS]]
    })

    function noWhitespaceValidator(control: AbstractControl) {
      const isWhitespace = (control.value || '').trim().length === 0;
      const isValid = !isWhitespace;
      return isValid ? null : { 'required': true };
    }

    function ValidateHTMLTAGS(control: AbstractControl){
      if(control.value){
        const res = control.value.replace(/ /g, '')
        let scriptRegex = /<(.*)>/g;
        if(res && (scriptRegex.test(res.trim()) == true)){
          return { 'pattern': true }
        }else{
          return null
        }
      }
    }

    this.route.queryParams.subscribe(params => {
      if(params && params['first-extract'] == 'true'){
        this.searchExample(1)
      }
    });


  }

  sendMessagetoChrome() {
    let chromeid = localStorage.getItem('extensionID');
    if (chromeid) {
      try {
        window['chrome'].runtime.sendMessage(chromeid, { action: 'getSimilarCandidateResult' }, (res)=> {
          if (res.similarCandidateData) {
            this.isExtensioninstalled  = true
          }
        });
      } catch (error) {
        if (error) {
          this.isExtensioninstalled  = false
        }
        console.error('Here is the error message', error);
      }
    }
  }

  getAutoCompleteData(dropdowntype: any, searchedstring: any): Observable<any> {
    let data = {
      dropdowntype: dropdowntype,
      searchedstring: searchedstring,
    };
    var subject = new Subject<any>();
    this.searchtoolbox.getAutoCompleteDataList(data).subscribe((res: any) => {
      if (res.status == "success") {
        subject.next(res.data);
      } else {
        subject.next([]);
      }
    });
    return subject.asObservable();
  }

  searchAutoCompletedData(e, type) {
    let data = e && e.target && e.target.value ? e.target.value : e.query
    if (data.length > 2) {
      this.getAutoCompleteData(type, data).subscribe((res) => {
        if (res && res.length) {
          if (type == "job titles") {
            this.filteredJobTitleOptions = res;
          } else if (type == "skills") {
            this.filteredMandatorySkillsOptions = res
          } else if (type == "companies") {
            this.filteredCompaniesOptions = res
          } else if (type == "locations") {
            this.filteredLocationsOptions = res
          }
        }
      });
    }
  }

  addDataToRequest(value, type, action) {
    if (value && value.trim != '') {
      const safeValue = this.sanitizeInput(value.trim());

      if (!safeValue) return;
      if (type == "job titles") {
        if (action) {
          this.jobtitles.push(safeValue);
          this.filteredJobTitleOptions = []
        }
        this.getRelatedData('Job Title', safeValue)
      } else if (type == "mandatory skills") {
        if (action) {
          this.mandatoryskills.push(safeValue);
          this.filteredMandatorySkillsOptions = []
        }
        this.getRelatedData('Skill', safeValue)
      } else if (type == "preferred skills") {
        if (action) {
          this.preferredskills.push(safeValue);
          this.filteredPreferredSkillsOptions = []
        }
        this.getRelatedData('Skill', safeValue)
      } else if (type == "excludekeywords") {
        this.excludekeywords.push(safeValue);
      } else if (type == "locations" && action) {
        this.locations.push(safeValue);
        this.filteredLocationsOptions = []
      } else if (type == "companies" && action) {
        let companynameobj = {
          company_name: safeValue
        }
        this.companies.push(companynameobj)
        this.filteredCompaniesOptions = []
      }
    }
  }

  escapeHtml(input: string): string {
  const div = document.createElement('div');
  div.innerText = input;
  return div.innerHTML;
}

  removeSelectedChip(value, type) {
    if (type == "job titles") {
      this.jobtitles = __.reject(this.jobtitles, value)
      this.deselectedJobTitlesArray.push(value)
      this.getRelatedData('Job Title', value, 'remove')
    } else if (type == "mandatory skills") {
      this.mandatoryskills = __.reject(this.mandatoryskills, value)
      this.deselectedSkillsArray.push(value)
      this.getRelatedData('Skill', value, 'remove')
    } else if (type == "preferred skills") {
      this.preferredskills = __.reject(this.preferredskills, value)
      this.deselectedSkillsArray.push(value)
      this.getRelatedData('Skill', value, 'remove')
    } else if (type == "locations") {
      this.locations = __.reject(this.locations, value)
    } else if (type == "companies") {
      this.companies = __.reject(this.companies, value.company_name)
    } else if (type == "excludekeywords") {
      this.excludekeywords = __.reject(this.excludekeywords, value)
    }
  }


  SelectSearchPlatform(value, action?) {
    if (action) {
      this.startindex = 0
      this.pageNumber = 1
    }
    if (value != 'LinkedIn') {
      this.categorySelected = null
    }

    if (this.booleanquery) {
      this.searchBooleanQuery(value)
    } else {
      this.generateBooleanAndSearch(value)
    }
  }

  setPage(index) {
    this.getResultForLinkedin.forEach(x => {
      x.selected = false
    })
    this.candidatetoBeGrabbed = []
    this.totalCandidatetoSendEmail = []
    this.totalCandidateforTalentpool = []
    this.totalCandidatetoRevealContacts = []
    this.selected = false
    this.pageNumber = index
    const tempIndex = index - 1

    if(this.platformselected != 'LinkedIn'){
      this.startindex = tempIndex * 10;
    }


    this.SelectSearchPlatform(this.platformselected)
  }

  generateBooleanAndSearch(value?) {
    this.getResultForLinkedin = []
    this.searchResults = []
    window.scrollTo(0, 0)
    this.platformselected = value
    if (this.jobtitles.length || this.mandatoryskills.length || this.preferredskills.length || this.locations.length || this.companies.length || this.excludekeywords.length) {
      this.fieldsRequired = false
      let data = {
        "startindex": this.startindex,
        "usernumber": this._localstorageservice.getItem('usernumber'),
        "currentjobtitle": this.isCurrentJobTitle ? true : false,
        "currentcompany": this.isCurrentCompany ? true : false,
        "opentowork": this.isOpentoWork ? true : false,
        "jobtitles": this.jobtitles,
        "preferredskills": this.preferredskills,
        "mandatoryskills": this.mandatoryskills,
        "locations": this.locations,
        "companies": this.companies.map(x => x.company_name),
        "synonyms": this.synonyms,
        "exclusionlist": this.excludekeywords,
        "calledviawebapp": true,
        "refinementtags": this.categorySelected && this.categorySelected != 'All' ? [this.categorySelected] : []
      }
      let apiname = this.platformlist.filter(x => x.platforname == this.platformselected)[0].apiname
      this.searchtoolbox[apiname](data).subscribe((res: any) => {
        this.talentpoolservice.bulkGrabStatus().subscribe((result: any) => {
          if(result && result.status == 'success'){
            this.bulkGrabbingDonePreviously = result.bulkGrabbingDonePreviously;
          }
        });
        this.searchCalled = true;
        this.showSearchResult = true
        // let searchResult: any[] = res.data.searchResults ? res.data.searchResults : []
        // this.searchResults =  this.searchResults.concat(searchResult)
        if(this.platformselected == 'LinkedIn'){
          const totalResultCount:number = res.data.totalResults
          this.isNextPagePresent = res.data.nextSearchPagePresent

          this.getResultForLinkedin = res.data.searchResults
          this.maxPageSize = Math.floor(this.getResultForLinkedin.length  / 30)
          this.searchResults = this.getResultForLinkedin.slice(0, 30);
        }else{
          this.searchResults = res.data.searchResults
        }

        this.searchResults = this.searchResults.reduce((unique, item) => {
          if (!unique.find((obj) => obj.htmlFormattedUrl === item.htmlFormattedUrl)) {
            unique.push(item);
          }
          return unique;
        }, []);

        this.searchQuerySentToCSE = res.data.searchqueryforCSE
        this.searchResultNextPage = res.data.nextSearchPagePresent
        this.totalSearchResultsCount = this.platformselected == 'LinkedIn' && res.data.totalResults ? res.data.totalResults : 0
        this.isNextPagePresent = res.data.nextSearchPagePresent
        // this.getCseResult()
        // if (this.totalSearchResultsCount > 100) {
        //   this.totalSearchResultsCount = 100
        // }
        this.booleanquery = res.data.booleanquery
        this.booleanquery_to_display = res.data.booleanquery.replace(/AND/g, '<span class="text-bluex"> AND </span>').replace(/OR/g, '<span class="text-bluex"> OR </span>')
          .replace(/[\(]/g, '<span class="text-9696"> ( </span>').replace(/[\)]/g, '<span class="text-9696"> ) </span>')
        if (this.isOpentoWork) {
          this.booleanquery_to_display = this.booleanquery_to_display + '<span class="text-bluex"> AND </span> ("Open to work")'
        }
        if (this.totalSearchResultsCount > 0) {
          this.refinementTags = res.data.refinementTags
        }
        var today = new Date();
        var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
        var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        var dateTime = date+' '+time;
        this.globalClevertapEvents = {
          "userid" : this._localstorageservice.getItem('userid'),
          "searchtoolboxversion" : 'V3.0',
          "jobtitles" : [this.jobtitles].toString(),
          "preferredskills" : [this.preferredskills].toString(),
          "mandatoryskills" : [this.mandatoryskills].toString(),
          "locations" : [this.locations].toString(),
          "companies" : [this.companies.map(x => x.company_name)].toString(),
          "platformsaccessed" : this.platformselected,
          "exclusionlist" : [this.excludekeywords].toString(),
          "gender" : this.categorySelected,
          "createdon" :dateTime,
          "synonyms" : [this.synonyms].toString(),
          "currentjobtitle" : this.isCurrentCompany ? true : false,
          "currentcompany" : this.isCurrentCompany ? true : false,
          "opentowork" :this.isOpentoWork ? true : false,
          "searchedviabooleanquery" : false ,
          "booleanquery" : [ "'" + this.booleanquery + "'"].toString() ,

        }
   //   this.cleverTapEvent("SearchToolbox_Search", this.globalClevertapEvents);
      })
    } else {
      this.fieldsRequired = true
    }
  }

  changeCategory(value) {
    this.searchResults = []
    this.getResultForLinkedin = []
    this.viewMoreClicked = 1;
    this.startindex = 0
    this.pageNumber = 1
    this.categorySelected = value
    this.SelectSearchPlatform(this.platformselected)
    let event = {
      target: {
        checked: false
      }
    }
    this.selectAll(event)
  }

  selectCandidate(e, data) {
    if ((e && e.target && e.target.checked) || e == 'selected') {
      if (this.candidatetoBeGrabbed && this.candidatetoBeGrabbed.length < 100) {
        this.candidatetoBeGrabbed.push(data)
        data.selected = true
      } else {
        data.selected = false
        e.target.checked = false;
      }
    } else {
      data.selected = false
      e.target.checked = false;
      this.candidatetoBeGrabbed = this.candidatetoBeGrabbed.filter(x => x['formattedUrl'] != data.formattedUrl)
    }
    // this.candidatetoBeGrabbed = __.uniq(this.candidatetoBeGrabbed,"formattedUrl")
    // this.totalCandidatetoSendEmail = this.candidatetoBeGrabbed.filter(x => x.pdlenrichmentviewed && x.emails && x.emails.length)
    // this.totalCandidateforTalentpool = this.candidatetoBeGrabbed.filter(x => x.pdlenrichmentviewed)
    // this.totalCandidatetoRevealContacts = this.candidatetoBeGrabbed.filter(x => !x.pdlenrichmentviewed)
    // this.totalcandidatesForGrabString = "Total " + this.candidatetoBeGrabbed.length + " candidates selected"
  }


  getAllTalentpool() {
    this.talentpoolservice.getTalentpoolList(this._localstorageservice.getItem('usernumber')).subscribe((res: any) => {
      if (res.status == "success") {
        if (this.talentpoolname != undefined && this.talentpoolname != null) {
          this.talentpoolslist = res.data.talentpools.filter((x) => { return x.name.toLowerCase().includes(this.talentpoolname.toLowerCase()) });
          this.talentpoolFound = this.talentpoolslist.find(x => (x.name == this.talentpoolname));
        } else {
          this.talentpoolslist = res.data.talentpools
        }
        if (this.talentpoolFound == undefined && this.talentpoolname && this.talentpoolname.trim() != '') {
          this.noTalentpoolError = true
        } else {
          this.noTalentpoolError = false
        }
      }
    })
  }

  openGrabModal() {
    if (this._localstorageservice.getItem('totalgrabcandidate') > 0) {
      this.modalService.open(this.GrabInProgress, { windowClass: "myCustomModalClass", centered: true });
    } else {
      this.modalService.open(this.grabModal, { windowClass: "myCustomModalClass", centered: true });
    }
  }

  doBulkExtraction() {
    let data = {}
    let platform = this.platformselected == 'LinkedIn' ? 'linkedin' : this.platformselected == 'GitHub' ? 'github' : this.platformselected == 'Stack Overflow' ? 'stackoverflow' : null;
    data['platform'] = platform;
    this.searchtoolbox.bulkextractionstatus().subscribe((res: any) => {
      if (res.bulkextractioninprogress == true) {
        this.modalService.open(this.GrabInProgress, { windowClass: "myCustomModalClass", centered: true });
      } else {
        if (this.talentpoolFound && this.talentpoolFound.talentpoolnumber) {
          data['talentpoolnumber'] = this.talentpoolFound.talentpoolnumber
        }

        if (this.candidatetoBeGrabbed && this.candidatetoBeGrabbed.length) {
          data['profileurlsarray'] = this.candidatetoBeGrabbed
          this.BulkExtractCandidate(data)
        } else if (this.totalcandidatesForGrab > 20) {
          this.ErrorMessage = "Only 20 candidates are allowed"
        } else if (this.totalcandidatesForGrab) {
          // if (this.totalcandidatesForGrab > 10) {
          //   this.userSelectedData.startindex = 11
          //   this.searchtoolbox.linkedInSearch(this.userSelectedData).subscribe((res: any) => {
          //     if (res.status == 'success') {
          //       let tempresults = []
          //       tempresults = res.data.searchResults
          //       if (res.data.totalResults > 0) {
          //         let searchResults = [...this.searchResults, ...tempresults]
          //         data['profileurlsarray'] = searchResults.slice(0, this.totalcandidatesForGrab).map(x => { return x.link })
          //         this.BulkExtractCandidate(data)
          //       }
          //     }
          //   })
          // } else {
          data['profileurlsarray'] = this.searchResults.slice(0, this.totalcandidatesForGrab).map(x => { return x.link })
          this.BulkExtractCandidate(data)
          // }
        } else if (this.candidatetoBeGrabbed.length == 0 && !this.totalcandidatesForGrab) {
          this.ErrorMessage = "Please Enter no of candidates"
        }
      }
    })
  }

  BulkExtractCandidate(data) {
    if (data.profileurlsarray && data.profileurlsarray.length && !this.noTalentpoolError) {
      this.ErrorMessage = ''
      this.searchtoolbox.bulkgrab(data).subscribe((res: any) => {
        if (res.message == 'insufficient credits') {
          this.modalService.open(this.noCreditsGrab, { windowClass: "myCustomModalClass", centered: true });
          // this.sendmailexpiry('Bulk Grabbing')
        } else if (res.status == 'success') {
          this.searchResults = this.searchResults.map((x: any) => {
            let res = x
            x.selected = false
            return res;
          })
          this.selected = false
          this.searchtoolbox.passGrabCandidateData(data)
          this.candidatetoBeGrabbed = []
          this.talentpoolFound = null
          this.modalService.open(this.GrabStarted, { windowClass: "myCustomModalClass", centered: true });
        } else {
          this.modalService.dismissAll()
          this.searchResults = this.searchResults.map((x: any) => {
            let res = x
            x.selected = false
            return res;
          })
          this.selected = false
          this.candidatetoBeGrabbed = []
          this.talentpoolFound = null
          this.errorMessage = res.message;
          setTimeout(() => this.errorMessage = '', 5000);
        }
      })
    }

  }
  showAdditionalFields(value) {
    this.additionfields = value
  }

  selectMapping(e, value) {
    if (e.target.checked) {
      if (this.tabActive == 'pboolean') {
        this.boolean_synonyms.push(value.mappingcode)
      } else {
        this.synonyms.push(value.mappingcode)
      }
    } else {
      if (this.tabActive == 'pboolean') {
        this.boolean_synonyms = this.boolean_synonyms.filter(x => x != value.mappingcode)
      } else {
        this.synonyms = this.synonyms.filter(x => x != value.mappingcode)
      }
    }
  }

  resetAllFields() {
    this.startindex = 0
    this.pageNumber = 1
    this.candidatetoBeGrabbed = []
    this.totalCandidatetoSendEmail = []
    this.totalCandidateforTalentpool = []
    this.totalCandidatetoRevealContacts = []
    this.fieldsRequired = false
    this.jdParseError = false
    this.isCurrentJobTitle = false
    this.isCurrentCompany = false
    this.booleanquery = null
    this.isOpentoWork = false
    this.jobtitles = []
    this.mandatoryskills = []
    this.preferredskills = []
    this.locations = []
    this.companies = []
    this.synonyms = []
    this.boolean_synonyms = []
    this.excludekeywords = []
    this.recommendedjobtitle = []
    this.recommendedskills = []
  }


  openHistoryModal() {
    this.modalService.open(this.historymodal, { windowClass: "myCustomModalClass", centered: true })
    this.gethistory()
  }

  gethistory(index?) {
    if (index) {
      this.starthistory = this.starthistory + 10
    } else {
      this.searchToolboxHistory = []
    }
    let data = {
      "startindex": this.starthistory,
      "usernumber": this._localstorageservice.getItem('usernumber')
    }
    this.searchtoolbox.fetchsearchtoolboxhistory(data).subscribe((res: any) => {
      if (res.status == 'success') {
        let response = res.data;
        this.searchToolboxHistory = this.searchToolboxHistory.concat(response.searchhistoryrecords)
      } else {
        console.log("Some error in loading history!");
      }
    })
  }

  searchBooleanQuery(value?,updated?) {
    this.isLoading = true;
    this.booleanquery = this.booleanquery?.replace( /(<([^>]+)>)/ig, '');
    let event = {
      target: {
        checked: false
      }
    }
    this.searchResults = [];
    this.selectAll(event)
    if (this.booleanquery && this.booleanquery.trim != '') {
      this.Boolean_fieldsRequired = false
      const platformselected = value
      let data = {
        "startindex": this.startindex,
        "usernumber": this._localstorageservice.getItem('usernumber'),
        "booleanquery": this.booleanquery,
        "searchplatform": platformselected,
        "synonyms": this.boolean_synonyms,
        "refinementtags": this.categorySelected && this.categorySelected != 'All' ? [this.categorySelected] : []
      }

      if (updated) {
        // this.editBooleanQuery = false
        this.getResultForLinkedin = []
        this.pageNumber = 1
        data['booleanquerygeneratedafterupdation'] = true
        data.startindex = 1
        this.booleanquery_to_display = this.booleanquery.replace(/AND/g, '<span class="text-bluex"> AND </span>').replace(/OR/g, '<span class="text-bluex"> OR </span>')
        .replace(/[\(]/g, '<span class="text-9696"> ( </span>').replace(/[\)]/g, '<span class="text-9696"> ) </span>')
        if (this.isOpentoWork) {
          this.booleanquery_to_display = this.booleanquery_to_display + '<span class="text-bluex"> AND </span> ("Open to work")'
        }
        this.searchResults = []
      }

      this.showLoading = true;
      data['calledviawebapp'] = true

      if(platformselected == 'LinkedIn'){
        const tempIndex = this.pageNumber - 1
        if(this.getResultForLinkedin.length > (tempIndex * 30)  &&  (this.getResultForLinkedin.length - (tempIndex * 30) >= 30)){

          this.searchResults = this.getResultForLinkedin.slice(tempIndex * 30 ,  (tempIndex + 1) * 30)
          this.showSearchResult = true;
          this.platformselected = value;
          this.isLoading = false;

        }else{
          this.searchtoolbox.searchviaboolean(data).subscribe((res: any) => {
            if(res.status == 'success'){
              this.startindex =  this.startindex + 100
              this.showLoading = false
              this.showSearchResult = true
              this.searchResults = res.data.searchResults ? res.data.searchResults : []
              this.platformselected = value;
              this.isLoading = false;

              if(platformselected == 'LinkedIn'){
                const totalResultCount: number  = res.data.totalResults

                this.isNextPagePresent = res.data.nextSearchPagePresent
                this.getResultForLinkedin = this.getResultForLinkedin.concat(this.searchResults)
                this.maxPageSize = Math.floor(this.getResultForLinkedin.length  / 30)
                const tempIndex = this.pageNumber - 1
                this.searchResults = this.getResultForLinkedin.slice(tempIndex * 30, ((tempIndex + 1) * 30))

                if(res.data.totalResults == 0){
                  this.searchResults = []
                }

              }

              this.searchResults = this.searchResults.reduce((unique, item) => {
                if (!unique.find((obj) => obj.htmlFormattedUrl === item.htmlFormattedUrl)) {
                  unique.push(item);
                }
                return unique;
              }, []);

              this.searchQuerySentToCSE = res.data.searchqueryforCSE
              this.searchResultNextPage = res.data.nextSearchPagePresent
              this.totalSearchResultsCount = this.platformselected == 'LinkedIn' && res.data.totalResults ? res.data.totalResults : 0
              this.isNextPagePresent = res.data.nextSearchPagePresent
              // this.getCseResult()
              // if (this.totalSearchResultsCount > 100) {
              //   this.totalSearchResultsCount = 100
              // }
              this.booleanquery_to_display = this.booleanquery.replace(/AND/g, '<span class="text-bluex"> AND </span>').replace(/OR/g, '<span class="text-bluex"> OR </span>')
                .replace(/[\(]/g, '<span class="text-9696"> ( </span>').replace(/[\)]/g, '<span class="text-9696"> ) </span>')
              if (this.isOpentoWork) {
                this.booleanquery_to_display = this.booleanquery_to_display + '<span class="text-bluex"> AND </span> ("Open to work")'
              }
              if (this.totalSearchResultsCount > 0) {
                this.refinementTags = res.data.refinementTags
              }
            }else{
              this.toastmessage('Something went wrong, Please try again in a minute', 'error')
            }
          })
        }
      }else{
        this.searchtoolbox.searchviaboolean(data).subscribe((res: any) => {
          if(res.status == 'success'){
            this.showLoading = false
            this.showSearchResult = true
            this.searchResults = res.data.searchResults ? res.data.searchResults : []
            this.platformselected = value;
            this.isLoading = false;

            if(this.platformselected == 'LinkedIn'){
              const totalResultCount:number  = res.data.totalResults
              this.isNextPagePresent = res.data.nextSearchPagePresent
              this.getResultForLinkedin = this.getResultForLinkedin.concat(this.searchResults)
              this.maxPageSize = Math.floor(this.getResultForLinkedin.length  / 30) + 1
              this.searchResults = this.getResultForLinkedin.slice(this.pageNumber * 30, ((this.pageNumber + 1) * 30))
            }

            this.searchResults = this.searchResults.reduce((unique, item) => {
              if (!unique.find((obj) => obj.htmlFormattedUrl === item.htmlFormattedUrl)) {
                unique.push(item);
              }
              return unique;
            }, []);

            this.searchQuerySentToCSE = res.data.searchqueryforCSE
            this.searchResultNextPage = res.data.nextSearchPagePresent
            this.totalSearchResultsCount = this.platformselected == 'LinkedIn' && res.data.totalResults ? res.data.totalResults : 100
            this.isNextPagePresent = res.data.nextSearchPagePresent
            // this.getCseResult()
            // if (this.totalSearchResultsCount > 100) {
            //   this.totalSearchResultsCount = 100
            // }
            this.booleanquery_to_display = this.booleanquery.replace(/AND/g, '<span class="text-bluex"> AND </span>').replace(/OR/g, '<span class="text-bluex"> OR </span>')
              .replace(/[\(]/g, '<span class="text-9696"> ( </span>').replace(/[\)]/g, '<span class="text-9696"> ) </span>')
            if (this.isOpentoWork) {
              this.booleanquery_to_display = this.booleanquery_to_display + '<span class="text-bluex"> AND </span> ("Open to work")'
            }
            if (this.totalSearchResultsCount > 0) {
              this.refinementTags = res.data.refinementTags
            }
          }else{
            this.toastmessage('Something went wrong, Please try again in a minute', 'error')
          }
        })
      }



      var today = new Date();
      var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      var dateTime = date+' '+time;
      this.globalClevertapEvents = {
        "userid" : this._localstorageservice.getItem('userid'),
        "searchtoolboxversion" : 'v3.0',
        "jobtitles" : [this.jobtitles].toString(),
        "preferredskills" : [this.preferredskills].toString(),
        "mandatoryskills" : [this.mandatoryskills].toString(),
        "locations" : [this.locations].toString(),
        "companies" : [this.companies.map(x => x.company_name)].toString(),
        "platformsaccessed" : this.platformselected,
        "exclusionlist" : [this.excludekeywords].toString(),
        "gender" : this.categorySelected,
        "createdon" :dateTime,
        "synonyms" : [this.synonyms].toString(),
        "currentjobtitle" : this.isCurrentCompany ? true : false,
        "currentcompany" : this.isCurrentCompany ? true : false,
        "opentowork" :this.isOpentoWork ? true : false,
        "searchedviabooleanquery" : ["'" + this.booleanquery + "'"].toString() ,
        "booleanquery" : false ,

      }
     // clevertap.event.push("SearchToolbox_Search" ,this.globalClevertapEvents);
    } else {
      this.Boolean_fieldsRequired = true
    }
  }


  backToBbuilder() {
    this.showSearchResult = false;
    this.categorySelected = 'All';
    this.startindex = 0;
    this.starthistory = 0
    this.pageNumber = 1
    this.refinementTags = [];
    this.gethistory()
    this.searchCalled = false;
  }

  uploadFile(event) {
    this.resetFormFields();
    this.uploadedFile = event.target.files[0];

    let validFileExtensions = ['doc', 'docx', 'pdf', 'txt'];
    let uploadedFileExtension = this.uploadedFile.name.split('.')[1];
    let filenameRegex = /[!@#$%^&*()+\=\[\]{};':"\\|,.<>\/?]/;

    if (!validFileExtensions.includes(uploadedFileExtension.toLowerCase())) {
      this.incorrectFileFormat = true;
    }
    if (filenameRegex.test(this.uploadedFile.name.split(".")[0])) {
      this.specialCharaterError = true;
    }
    // Verify file size (File size cannot exceed 5 MB)
    if (this.uploadedFile.size > 5242880) {
      this.fileSizeLimitExceeded = true;
    }

    if (this.uploadedFile && !this.specialCharaterError && !this.incorrectFileFormat && !this.fileSizeLimitExceeded) {
      this.isUploadedFileCorrect = true;
      this.uploadedFilename = this.uploadedFile.name;
      this.disableManualJDInput = true;
    }

  }

  addJobDescription() {
    if ((this.enteredJobDescription && this.enteredJobDescription.toString().trim().length)
      || (this.uploadedFile && this.isUploadedFileCorrect)) {
      let data = {
        usernumber: this._localstorageservice.getItem('usernumber')
      }

      // Process uploaded JD file
      if (!this.enteredJobDescription || this.enteredJobDescription.toString().trim().length == 0) {
        GlobalService.toBase64(this.uploadedFile).then(encodedFileData => {
          data['isbase64encoded'] = 'yes';
          data['jobdescription'] = encodedFileData;
          data['filename'] = 'jobDescription.' + this.uploadedFile.name.split('.')[1];
          this.parseJobDescription(data);
        })
      }
      // Process the manually added JD
      else {
        data['isbase64encoded'] = 'no';
        data['jobdescription'] = this.enteredJobDescription.toString().trim();
        data['filename'] = 'jobDescription.txt';
        this.parseJobDescription(data);
      }
    } else {
      this.showJDNotAddedError = true;
    }
  }

  resetFormFields() {
    this.enteredJobDescription = '';
    this.incorrectFileFormat = false;
    this.specialCharaterError = false;
    this.isUploadedFileCorrect = false;
    this.uploadedFilename = undefined;
    this.disableManualJDInput = false;
    this.showJDNotAddedError = false;
    this.fileSizeLimitExceeded = false;
  }

  updateTabToShow(value, action) {
    if (action) {
      this.jdMode = false
    }
    if (value != this.tabActive) {
      if (value != 'jdmode') {
        this.jdMode = false
      }
      if (value == 'jdmode') {
        this.resetFormFields()
      }
      this.tabActive = value
    }
  }

  parseJobDescription(data: any) {
    this.searchtoolbox.parseJobDescription(data).subscribe((res: any) => {
      if (res.data) {
        this.jdParseError = false
        this.jobtitles = res.data.jobtitles;
        this.mandatoryskills = res.data.mandatoryskills;
        this.preferredskills = res.data.preferredskills;
        this.locations = res.data.locations;
        this.jdMode = true
        this.additionfields = true
        this.repeatSuggestion()
      } else if (res.status == 'failure' && res.message == 'insufficient credits') {
        clevertap.event.push('JDParse_CreditExpiry')
        this.modalService.open(this.noCreditsJDParse, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
      } else {
        this.jdParseError = true
      }
    });
  }

  clearEnteredJD() {
    this.enteredJobDescription = '';
  }

  copyBooleanQuery() {
    var dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = this.booleanquery
    if (this.isOpentoWork) {
      dummy.value = dummy.value + ' AND ("Open to work")'
    }
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    this.successMessage = "Boolean string copied succesfully"
    setTimeout(() => this.successMessage = '', 5000);
  }

  repeatSearch(data, type?) {
    this.searchResults = []
    this.modalService.dismissAll()
    this.resetAllFields();
    this.jobtitles = data.jobtitles ? data.jobtitles.split('; ') : []
    this.locations = data.locations ? data.locations.split('; ') : []
    this.isCurrentCompany = data.currentcompany ? true : false
    this.isCurrentJobTitle = data.currentcompany ? true : false
    this.isOpentoWork = data.opentowork ? true : false
    this.mandatoryskills = data.mandatoryskills ? data.mandatoryskills.split('; ') : []
    this.preferredskills = data.preferredskills ? data.preferredskills.split('; ') : []
    if (type && this.preferredskills && this.preferredskills.length) {
      this.preferredskills = this.preferredskills.slice(0, 5)
    }
    this.excludekeywords = data.exclusionlist ? data.exclusionlist.split('; ') : []
    let companies = data.companies ? data.companies.split('; ') : []
    if (companies.length > 0) {
      let companynameobj;
      companies.map(x => {
        companynameobj = {
          company_name: x
        }
        this.companies.push(companynameobj)
      })
    }
    if (data.booleanquery) {
      this.booleanquery = data.booleanquery
      this.boolean_synonyms = data.synonyms ? data.synonyms.split('; ') : []
      // this.tabActive = 'pboolean'
    } else {
      this.synonyms = data.synonyms ? data.synonyms.split('; ') : []
    }
    // data.refinementtags
    if (data.refinementtags) {
      this.categorySelected = data.refinementtags
    }
    if (this.preferredskills.length || this.locations.length || this.companies.length || this.excludekeywords.length) {
      this.additionfields = true
    }
    this.repeatSuggestion()
    this.SelectSearchPlatform(data.platformsaccessed)
  }

  repeatSuggestion() {
    // To get related suggestions
    let value;
    let searchedParameter;
    if (this.jobtitles && this.jobtitles.length) {
      value = this.jobtitles[this.jobtitles.length - 1];
      searchedParameter = 'Job Title';
    } else if (this.preferredskills && this.preferredskills.length) {
      value = this.preferredskills[this.preferredskills.length - 1];
      searchedParameter = 'Skill';
    } else if (this.mandatoryskills && this.mandatoryskills.length) {
      value = this.mandatoryskills[this.mandatoryskills.length - 1];
      searchedParameter = 'Skill';
    }
    if (value) {
      this.getRelatedData(searchedParameter, value)
    }
  }
  getHistoryHeadline(history) {
    return history.jobtitles ? history.jobtitles : history.mandatoryskills ? history.mandatoryskills : history.preferredskills ? history.preferredskills : history.locations ? history.locations : history.booleanquery
  }

  searchExample(index) {
    this.searchResults = [];
    this.resetAllFields()
    if (index == '1') {
      this.jobtitles = ['Software Engineer', 'SDE']
      this.isCurrentJobTitle = true
      this.additionfields = true
      this.mandatoryskills = ['programming']
      this.locations = ['San Francisco, California, United States']
      this.categorySelected = 'women'
      this.synonyms = ['TXWXMXN']
    } else if (index == '2') {
      this.jobtitles = ['ui/ux designer']
      this.isCurrentJobTitle = false
      this.isCurrentCompany = true
      this.additionfields = true
      this.companies = [{
        company_name: 'Freelance'
      }, {
        company_name: 'Freelancer'
      }]
      this.locations = ['London', 'England', 'United Kingdom']
    } else if (index == '3') {
      this.jobtitles = ['senior electrical engineer']
      this.isCurrentJobTitle = true
      this.additionfields = true
      this.excludekeywords = ['junior']
      this.locations = ['New York', 'United States']
    }
    this.repeatSuggestion()
    this.SelectSearchPlatform('LinkedIn')
  }

  route2link() {
    window.open('https://support.google.com/programmable-search/answer/4542403?hl=en&ctx=topic&topic=2642374&visit_id=637788844274854332-2187257001&rd=1', "_blank");
  }


  getRelatedData(type: string, value: string, action?) {
    let data = {
      searchparameter: type,
      searchedstring: value.toString().trim().toLowerCase(),
      selectedjobtitlesarray: this.jobtitles.filter((x) => { return x != value }),
      selectedskillsarray: this.preferredskills.concat(this.mandatoryskills).filter((x) => { return x != value }),
      existingjobtitlessuggestionarray: this.recommendedjobtitle,
      existingskillssuggestionarray: this.recommendedskills,
      deselectedJobTitlesArray: this.deselectedJobTitlesArray,
      deselectedSkillsArray: this.deselectedSkillsArray
    }
    if (action == 'remove' && type == 'Job Title') {
      let selectedjob = data['selectedjobtitlesarray']
      data['searchedstring'] = selectedjob.length ? selectedjob[selectedjob.length - 1] : ''
      data['searchparameter'] = 'Job Title'
    } else if (action == 'remove' && type == 'Skill') {
      let selectedskill = data['selectedskillsarray']
      data['searchedstring'] = selectedskill.length ? selectedskill[selectedskill.length - 1] : ''
      data['searchparameter'] = 'Skill'
    }

    if (data.searchedstring.length) {
      this.searchtoolbox.recommendedData(data).subscribe((res: any) => {
        if (res.status == 'success') {
          this.recommendedjobtitle = res.data.related_job_titles
          this.recommendedskills = res.data.related_skills.filter((x) => x)
          this.filteredJobTitleOptions = []
          this.filteredPreferredSkillsOptions = []
          this.filteredMandatorySkillsOptions = []
        }
      });
    }
  }

  route2pricing() {
    this.modalService.dismissAll()
    if(this._localstorageservice.getItem('isteamMember')){
      this.modalService.open(this.requestCredit, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    }else{
      this.router.navigateByUrl('subscription/pricing')
    }
  }


  fetchcredits() {
    // Credits come from the shared signal (populated only on login and after reveal-contact
    // succeeds, see TransactionService) - no direct call to /paymentflow/fetchcurrentplancredits.
    const res: any = { data: this.transactionservice.credits() };
    if (res.data) {
        if (res.data.isteamadmin) {
          // Here the logged in person is a Team Admin
          this.subscriptiondetails.balancecontactenrichmentcredits = res.data.balancecontactenrichmentcredits;
          this.subscriptiondetails.balancebasiccontactenrichmentcredits = res.data.balancebasiccontactenrichmentcredits;
          this.subscriptiondetails.balancejdparsingcredits = res.data.pooledbalancejdparsingcredits;
          this.subscriptiondetails.balancesmartemailcredits = res.data.pooledbalancesmartemailcredits;
          this.subscriptiondetails.balancetalentpipelinecredits = res.data.pooledbalancetalentpipelinecredits;
        } else {
          if (res.data.teamadmindetails) {
            // Here the logged in person is a Team Member
            // this.isteamMember = true
            this.subscriptiondetails.balancebasiccontactenrichmentcredits = res.data.balancebasiccontactenrichmentcredits;
            this.subscriptiondetails.balancecontactenrichmentcredits = res.data.balancecontactenrichmentcredits;
            this.subscriptiondetails.balancejdparsingcredits = res.data.teamadmindetails.adminbalancejdparsingcredits;
            this.subscriptiondetails.balancesmartemailcredits = res.data.teamadmindetails.adminbalancesmartemailcredits;
            this.subscriptiondetails.balancetalentpipelinecredits = res.data.teamadmindetails.adminbalancetalentpipelinecredits;
          } else {
            // Here the logged in person is a normal (who does not belong to any team)
            this.subscriptiondetails.balancebasiccontactenrichmentcredits = res.data.balancebasiccontactenrichmentcredits;
            this.subscriptiondetails.balancecontactenrichmentcredits = res.data.balancecontactenrichmentcredits;
            this.subscriptiondetails.balancejdparsingcredits = res.data.balancejdparsingcredits;
            this.subscriptiondetails.balancesmartemailcredits = res.data.balancesmartemailcredits;
            this.subscriptiondetails.balancetalentpipelinecredits = res.data.balancetalentpipelinecredits;
          }
        }
        this.subscriptiondetails.smartemailcredits = res.data.smartemailcredits
        this._localstorageservice.setItem('jdcredits', this.subscriptiondetails.balancejdparsingcredits)
        this._localstorageservice.setItem('tpcredits', this.subscriptiondetails.balancetalentpipelinecredits)
        this._localstorageservice.setItem('cecredits', this.subscriptiondetails.balancecontactenrichmentcredits)
        this._localstorageservice.setItem('secredits', this.subscriptiondetails.balancesmartemailcredits)
      }
  }

  showfreecontactdetails(data) {
    if (!(this.subscriptiondetails.balancebasiccontactenrichmentcredits > 0 || this.subscriptiondetails.balancebasiccontactenrichmentcredits == -1)) {
      this.router.navigateByUrl('/subscription/pricing')
    } else {
      let requestOBJ = {
        datastore_candidatenumbers_array : data.datastore_candidatenumber ? data.datastore_candidatenumber : this.candidatetoBeGrabbed.map(x => x.datastore_candidatenumber).filter(x => x),
        candidatenumbers_array : data.candidatenumber ? data.candidatenumber : this.candidatetoBeGrabbed.map(x => x.candidatenumber).filter(x => x)
      }
      this.candidateservice.bulkrevealbasiccontacts(requestOBJ).subscribe((res:any)=>{
        if(res.status == 'success'){
          this.selected = false
          this.candidatetoBeGrabbed = []
          let event = {
            target: {
              checked: false
            }
          }
          this.selectAll(event)
          this.searchResults = this.searchResults.map(x =>{
            let response = x
            response.selected = false
            let CandidateDATA = res.data.filter(y =>
              (x.datastore_candidatenumber && (y.datastore_candidatenumber == x.datastore_candidatenumber) ||  x.candidatenumber && (y.candidatenumber == x.candidatenumber)))[0]
              if(CandidateDATA){
                response.datastore_candidatenumber = null
                // response.basic_details = response.CandidateDATA.basic_details
                response.candidatenumber = CandidateDATA.candidatenumber
                let contactDetails = CandidateDATA ? CandidateDATA.contact_details : null
                if (contactDetails) {
                  response.socialprofiles = contactDetails.socialprofile ? contactDetails.socialprofiles.moreAvailableDetails : []
                  response.contactnumbers = contactDetails.contactnumbers ? contactDetails.contactnumbers.newMoreAvailableDetails : []
                  response.emails = contactDetails.emails ? contactDetails.emails.newMoreAvailableDetails : []
                }
                try{
                  contactDetails.emails.existingDetails = contactDetails.emails.newMoreAvailableDetails
                  contactDetails.emails.newMoreAvailableDetails = []
                  response.contactdetails = contactDetails
                  response.CandidateDATA.contactdetails = contactDetails
                  response.CandidateDATA.contact_details = contactDetails
                }catch(e){
                  console.log(e , "error while mapping exisitng candidate data")
                }
                response.totalcontacts_from_pdl = 0
                response.pdlenrichmentviewed = 1
            }
            return response
          })
        }
      })
    }
  }

  getCseResult() {
    this.enrichResult = false
    if (this.searchResults && this.searchResults.length) {
      let data = {
        profileurlsarray: this.searchResults.map(x => x.formattedUrl)
      }
      this.searchtoolbox.enrichcseresults(data).subscribe((res: any) => {
        this.enrichResult = true
        if (res.data && res.data.length)
          this.searchResults = this.searchResults.map(x => {
            let response = x
            response.CandidateDATA = res.data.filter(y => y.link == x.formattedUrl)[0]
            if (response.CandidateDATA) {
              response.datastore_candidatenumber = response.CandidateDATA.datastore_candidatenumber
              response.basic_details = response.CandidateDATA.basic_details
              response.candidatenumber = response.CandidateDATA.candidatenumber
              let contactDetails = response.CandidateDATA ? response.CandidateDATA.contact_details : null
              if (contactDetails && !response.candidatenumber) {
                response.socialprofiles = contactDetails.socialprofile ? contactDetails.socialprofiles.moreAvailableDetails.concat(contactDetails.socialprofiles.existingDetails).filter(x =>x) : []
                response.contactnumbers = contactDetails.contactnumbers ? contactDetails.contactnumbers.newMoreAvailableDetails.concat(contactDetails.contactnumbers.existingDetails).filter(x =>x) : []
                response.emails = contactDetails.emails ? contactDetails.emails.newMoreAvailableDetails.concat(contactDetails.emails.existingDetails).filter(x =>x) : []
                // let moreSocialProfilesCount = (contactDetails.socialprofiles) ? (contactDetails.socialprofiles.numberOfMoreAvailableDetails) : 0;
                let moreEmailsCount = (contactDetails.emails) ? (contactDetails.emails.numberOfMoreAvailableDetails) : 0;
                let moreContactNumbersCount = (contactDetails.contactnumbers) ? (contactDetails.contactnumbers.numberOfMoreAvailableDetails) : 0;
                response.totalcontacts_from_pdl = moreEmailsCount + moreContactNumbersCount
              } else {
                response.socialprofiles = contactDetails.socialprofiles
                response.contactnumbers = contactDetails.contactnumbers
                response.emails = contactDetails.emails
              }
              response.jobtitle = response.CandidateDATA.basic_details.jobtitle
              response.locationname = response.CandidateDATA.basic_details.locationname
              response.companyname = response.CandidateDATA.basic_details.companyname
              response.piplenrichmentlastdoneon = response.CandidateDATA.basic_details.piplenrichmentlastdoneon
              response.pdlenrichmentviewed = response.CandidateDATA.basic_details.pdlenrichmentviewed
            }
            return response
          })
      })
    }
  }


  getSocialProfileIcon(platformName) {
    platformName = platformName.toLowerCase();
    let iconToBeShown, platformNameToBeDisplayed;
    switch (true) {
      case (platformName.includes('linkedin')):
        iconToBeShown = 'fab fa-linkedin-square';
        platformNameToBeDisplayed = 'LinkedIn';
        break;
      case (platformName.includes('angel')):
        iconToBeShown = 'fab fa-angellist';
        platformNameToBeDisplayed = 'AngelList';
        break;
      case (platformName.includes('facebook')):
        iconToBeShown = 'fab fa-facebook';
        platformNameToBeDisplayed = 'Facebook';
        break;
      case (platformName.includes('behance')):
        iconToBeShown = 'fab fa-behance';
        platformNameToBeDisplayed = 'Behance';
        break;
      case (platformName.includes('twitter')):
        iconToBeShown = 'fa-brands fa-square-x-twitter';
        platformNameToBeDisplayed = 'Twitter';
        break;
      case (platformName.includes('github')):
        iconToBeShown = 'fab fa-github';
        platformNameToBeDisplayed = 'GitHub';
        break;
      case (platformName.includes('instagram')):
        iconToBeShown = 'fab fa-instagram';
        platformNameToBeDisplayed = 'Instagram';
        break;
      case (platformName.includes('google')):
        iconToBeShown = 'fab fa-google';
        platformNameToBeDisplayed = 'Google';
        break;
      case (platformName.includes('dribbble')):
        iconToBeShown = 'fab fa-dribbble';
        platformNameToBeDisplayed = 'Dribbble';
        break;
      case (platformName.includes('youtube')):
        iconToBeShown = 'fab fa-youtube';
        platformNameToBeDisplayed = 'Youtube';
        break;
      case (platformName.includes('flickr')):
        iconToBeShown = 'fab fa-flickr';
        platformNameToBeDisplayed = 'Flickr';
        break;
      case (platformName.includes('foursquare')):
        iconToBeShown = 'fab fa-foursquare';
        platformNameToBeDisplayed = 'Foursquare';
        break;
      case (platformName.includes('gitlab')):
        iconToBeShown = 'fab fa-gitlab';
        platformNameToBeDisplayed = 'GitLab';
        break;
      case (platformName.includes('meetup')):
        iconToBeShown = 'fab fa-meetup';
        platformNameToBeDisplayed = 'Meetup';
        break;
      case (platformName.includes('pinterest')):
        iconToBeShown = 'fab fa-pinterest';
        platformNameToBeDisplayed = 'Pinterest';
        break;
      case (platformName.includes('quora')):
        iconToBeShown = 'fab fa-quora';
        platformNameToBeDisplayed = 'Quora';
        break;
      case (platformName.includes('soundcloud')):
        iconToBeShown = 'fab fa-soundcloud';
        platformNameToBeDisplayed = 'SoundCloud';
        break;
      case (platformName.includes('stack overflow') || platformName.includes('stackoverflow')):
        iconToBeShown = 'fab fa-stack-overflow';
        platformNameToBeDisplayed = 'Stack Overflow';
        break;
      case (platformName.includes('vimeo')):
        iconToBeShown = 'fab fa-vimeo';
        platformNameToBeDisplayed = 'Vimeo';
        break;
      case (platformName.includes('wordpress')):
        iconToBeShown = 'fab fa-wordpress';
        platformNameToBeDisplayed = 'Wordpress';
        break;
      case (platformName.includes('xing')):
        iconToBeShown = 'fab fa-xing';
        platformNameToBeDisplayed = 'Xing';
        break;
      default:
        iconToBeShown = 'fas fa-globe';
        platformNameToBeDisplayed = 'Other';
        break;
    }
    let data = {
      iconToBeShown: iconToBeShown,
      platformNameToBeDisplayed: platformNameToBeDisplayed
    }
    return data;
  }

  viewMore(i, type) {
    if (type == 'contact') {
      document.getElementById(`contact${i}`).classList.remove('d-none')
      document.getElementById(`contact_viewmore${i}`).classList.add('d-none')
    } else if (type == 'email') {
      document.getElementById(`emails${i}`).classList.remove('d-none')
      document.getElementById(`email_viewmore${i}`).classList.add('d-none')
    }
  }

  viewLess(i, type) {
    if (type == 'contact') {
      document.getElementById(`contact${i}`).classList.add('d-none')
      document.getElementById(`contact_viewmore${i}`).classList.remove('d-none')
    } else if (type == 'email') {
      document.getElementById(`emails${i}`).classList.add('d-none')
      document.getElementById(`email_viewmore${i}`).classList.remove('d-none')
    }
  }


  selectAll(e) {
    if (e.target.checked && this.candidatetoBeGrabbed.length < 100) {
      this.searchResults.forEach((x: any) => {
        let event = {
          target: {
            checked: true
          }
        }
        this.selectCandidate(event, x)
      })
    } else {
      this.totalCandidatetoSendEmail = []
      this.totalCandidateforTalentpool = []
      this.totalCandidatetoRevealContacts = []
      this.candidatetoBeGrabbed = []
      this.selected = false
      e.target.checked = false;
      this.searchResults.forEach((x: any) => {
        let event = {
          target: {
            checked: false
          }
        }
        this.selectCandidate(event, x)
      })
    }
  }

  findpremiumContact(candidate) {
      let data = {
        existingemailsarray: candidate.candidatenumber && candidate.emails ? candidate.emails.map(x => x.contactdetail) : [],
        existingsocialprofilesarray: candidate.candidatenumber && candidate.socialprofiles ? candidate.socialprofiles.map(x => x.link) : [],
        existingcontactnumbersarray: candidate.candidatenumber && candidate.contactnumbers ? candidate.contactnumbers.map(x => x.contactdetail) : []
      }
      if(candidate.candidatenumber){
        data['candidatenumber'] = candidate.candidatenumber
      }else if(candidate.datastore_candidatenumber){
        data['datastore_candidatenumber'] = candidate.datastore_candidatenumber
      }
      let apiName = candidate.candidatenumber ? 'premiumcontactenrichment' : 'addandenrichwithpartnercredits'
      this.candidateservice[apiName](data).subscribe((res: any) => {
        if (res.status == 'success') {
          this.searchResults = this.searchResults.map(x => {
            let response = x
            if (x.link == candidate.link) {
              response.candidatenumber = res.data.candidatenumber ? res.data.candidatenumber : response.candidatenumber
              response.datastore_candidatenumber = null
              response.piplenrichmentlastdoneon = 'datetoday'
              if (res.message == 'enrichment details available') {
                let newContacts = res.data.enrichedContactDetails ? res.data.enrichedContactDetails : res.data
                response.socialprofiles = response.socialprofiles ? response.socialprofiles.concat(newContacts.detailed_profileurls) : newContacts.detailed_profileurls
                response.contactnumbers = response.contactnumbers ? response.contactnumbers.concat(newContacts.detailed_contactnumbers) : newContacts.detailed_contactnumbers
                response.emails = response.emails ? response.emails.concat(newContacts.detailed_emails) : newContacts.detailed_emails
              }
            }
            return response
          })
        }
        // this.SelectSearchPlatform(this.platformselected)
      })

  }

  copyDATA(value ,id){
    var dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = value;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
  }

  sendEmail(data) {
    if(data.formattedUrl){
      var SearchToolbox_ExploreConnect_Result = {
        ...this.globalClevertapEvents,
        'url' : data.formattedUrl,
        'PageNo' : this.pageNumber,
      }
     // this.cleverTapEvent('SearchToolbox_ExploreConnect_Attempt',SearchToolbox_ExploreConnect_Result)
    }


    const modalRef = this.modalService.open(IntroCandidateemailComponent, { windowClass: 'myCustomModalClass', centered: true});
    modalRef.componentInstance.balancesmartemailcredits = this.subscriptiondetails.balancesmartemailcredits
    modalRef.componentInstance.smartemailcredits = this.subscriptiondetails.smartemailcredits
    if (data == 'bulk') {
      var SearchToolbox_ExploreConnect_Bulk_Attempt = {
        ...this.globalClevertapEvents,
        'PageNo' : this.pageNumber,
      }
    //  this.cleverTapEvent('SearchToolbox_ExploreConnect_Bulk_Attempt',SearchToolbox_ExploreConnect_Bulk_Attempt)
      if(this.candidatetoBeGrabbed && this.candidatetoBeGrabbed.length == 1){
        this.sendEmail(this.candidatetoBeGrabbed[0])
      }else{
        modalRef.componentInstance.candidateLinks = this.candidatetoBeGrabbed.map(x => x.formattedUrl)
        modalRef.componentInstance.SearchToolbox_ExploreConnect_Bulk_Attempt = SearchToolbox_ExploreConnect_Bulk_Attempt
      }
    } else {
      modalRef.componentInstance.candidateLinks = [data.formattedUrl]
      modalRef.componentInstance.candidateName = data.title.split(' - ')[0]
      modalRef.componentInstance.SearchToolbox_ExploreConnect_Result = SearchToolbox_ExploreConnect_Result
    }
    modalRef.componentInstance.passEntry.subscribe((x) => {
      let event = {
        target: {
          checked: false
        }
      }
      this.selectAll(event)
      if (x == 'emailsend') {
        this.toastmessage('Email Send Successfully', 'success')
        this.fetchcredits()
      } else if (x == 'nocredits') {
        this.modalService.open(this.noCreditsCE, { windowClass: "myCustomModalClass", centered: true });
      } else if (x == 'limitexceeded') {
        this.toastmessage('mail limit exceeded', 'error')
      } else if (x == 'error') {
        this.toastmessage('Something went Wrong', 'error')
      }
    })
  }

  addToTalentpool(data){
    const modalRef = this.modalService.open(AddToTalentpoolComponent, { size: 'lg' as 'lg', centered: true });
    modalRef.componentInstance.candidatetoAdd = data
    modalRef.componentInstance.BuldCandidatetoAdd = this.totalCandidateforTalentpool.map(x => x.candidatenumber)
    modalRef.componentInstance.passEntry.subscribe((x) => {
      if (x == 'candidateAdded') {
        this.toastmessage('Candidate Added to Talentpool Succesfully', 'success')
        let event = {
          target: {
            checked: false
          }
        }
        this.selectAll(event)
      } else if (x == 'alreadyexist') {
        this.toastmessage('Candidate already exist in talentpool', 'success')
      } else if (x == 'error') {
        this.toastmessage('Something went Wrong, Please try again in a minute', 'error')
      }
    })
  }

  formatDate(x) {
    let res = moment(x).format('Do MMM YY | hh:mm A')
    return res
  }


  toastmessage(message, type) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error')
      this.errorMessage = message;
    setTimeout(() => this.errorMessage = '', 5000);
  }

  routeURL() {
    window.open('https://chrome.google.com/webstore/detail/webbtree-chrome-extension/jlmhleoipeloancgdilegcelojacmpcm?utm_source=gmail', "_blank")
  }
  candidateCT(url){
    var SearchToolbox_Result = {
      ...this.globalClevertapEvents,
      'url' : url,
      'PageNo' : this.pageNumber,
    }
   // this.cleverTapEvent('SearchToolbox_Result',SearchToolbox_Result)
  }
  cleverTapEvent(eventName, data) {
    clevertap.event.push(eventName, data);
    console.log(eventName + " CT event");
  }

  sendEmailAndGrabCandidate(){
    this.profileurlsarray = []
    this.profileurlsarray = this.candidatetoBeGrabbed.map(x => x.link)
    this.profileurlsarray = this.profileurlsarray.filter((item,
      index) => this.profileurlsarray.indexOf(item) === index);
    const modalRef = this.modalService.open(this.extractToTalentpool, { windowClass: "modalExtract", centered: true });
    modalRef.result.then((data) => {
      // on close
    },
    (error) => {
      if(error != 'isGrabbed'){
        this.modalDismissed = true;
        this.saveDataToTalentpool(this.profileurlsarray)
      }
    });

  }

  talentPoolandCandidateDataEvent(event) {
    if(event.talentpoolname == '') {
      this.disablebutton = true;
      this.talentpoolAndCandidateData = null;
      return;
    }
    if (event) {
      this.disablebutton = false;
      this.talentpoolAndCandidateData = event
    }
  }

  saveDataToTalentpool(talentpoolData = null) {
    const profileurlsarray = {
      profileurlsarray: talentpoolData
    }
    let talentpoolProfileAndData = {}
    if (this.talentpoolAndCandidateData && this.talentpoolAndCandidateData.profileurlsarray && this.talentpoolAndCandidateData.profileurlsarray.length) {
      talentpoolProfileAndData = {
        talentpoolname: this.talentpoolAndCandidateData.talentpoolname,
        talentpoolnumber: this.talentpoolAndCandidateData.talentpoolnumber,
        elasticid: this.talentpoolAndCandidateData.profileurlsarray,
      }
    } else {
      console.error('UNABLE TO FIND ELASTIC ID')
    }
    this.addToTalentpoolSpinner = true;

    this.personSearchService.addToTanentpool(talentpoolProfileAndData).subscribe((result: any) => {
      this.disablebutton = true;
      if (result.status == 'success') {
        this.modalService.dismissAll('isGrabbed')
        this.candidatetoBeGrabbed = [];
        this.selected = false;
        this.toastmessage('Profile added to talentpool', 'success');
                /**
           * Add to talentpool
           */
                 const talentpoolParams = {
                  "User ID": this._localstorageservice.getItem('userdata').userid,
                  "Candidate ID": this.talentpoolAndCandidateData.profileurlsarray.toString(),
                  "Talentpool Name": this.talentpoolAndCandidateData.talentpoolname
                }
                clevertap.event.push('Add Candidate to Talentpool', talentpoolParams);
      } else if (result.status == 'failure') {
        if (result.message == 'User not on paid plan') {
          this.modalService.dismissAll()
          this.modalService.open(this.premiumUserError, { windowClass: "modalExtract", centered: true })
        }
        else if (result.bulkextractioninprogress) {
          this.toastmessage('Profile extraction already in progress. Please try again after sometime', 'error')
        } else if (result.message == 'already-added') {
          this.modalService.dismissAll()
          this.toastmessage('Candidate has already been added to this talentpool', 'error')
        }
        else {
          this.toastmessage('Something went Wrong', 'error')
        }
      }
    }, () => {

    }, () => {
      this.addToTalentpoolSpinner = false;
    });
  }

  extractCandidate(candidateData: any) {
    this.profileurlsarray = []
    this.profileurlsarray.push(candidateData.id)
    this.disablebutton = true;
    const modalRef = this.modalService.open(this.extractToTalentpool, { windowClass: "modalExtract", centered: true });
    modalRef.result.then((data) => {
    },
      (error) => {
        if (error != 'isGrabbed') {
          this.modalDismissed = true;
        }
      });
  }

  skipExtract(){
    this.searchCalled = false
  }

  bulkSelectAndExtract(){
    this.searchResults.forEach((x: any) => {
      let event = {
        target: {
          checked: true
        }
      }
      this.candidatetoBeGrabbed.push(x)
      x.selected = true
    })
    this.sendEmailAndGrabCandidate();
  }

  checkForDisabledButton(){
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen');
    //loadn[0].style.display = 'none'
    return this.viewMoreClicked >= Math.floor(this.totalSearchResultsCount / 10)
  }

  showResultCount(){
      if(this.platformselected == 'LinkedIn'){
        if(this.searchResults.length > 0){
          if(this.totalSearchResultsCount == 0){
            return 'Approx ' + this.getResultForLinkedin.length + ' results found'

          }else{

            return 'Approx ' + this.totalSearchResultsCount + ' results found'
          }
        }else if(this.searchResults.length == 0){
          return 'No results found'
        }
        else{
          'Approx ' + this.getResultForLinkedin + ' results found'
        }
      }else{
        return '100 Result Found'
      }

  }

  openSlider(data) {
    this.personSearchService.getdetailsfromlinkedin(data.link).subscribe((res: any) => {
      if (res.status == 'success') {
        if(res.message == 'Person not found') {
          this.toastmessage("Couldn't find Contact Details", 'error');
          return;
        }
        this.candidateservice.getCandidateDetails(res.data.id, 'elasticid').subscribe((response: any) => {
          if(response.status == 'success'){
            res.data.candidatenumber = response.data.candidatedetails.basicdetails[0].candidatenumber;
            res.data.usedWebbtreeIntroduction = response.data.candidatedetails.basicdetails[0].usedWebbtreeIntroduction;
            res.data.revealContactAttempted = response.data.candidatedetails.basicdetails[0].revealContactAttempted;
            res.data.iswebbtreeverified = response.data.candidatedetails.basicdetails[0].iswebbtreeverified;
          }
          res.data.idinindex = res.data.id
          this.currentCandidate = res.data;
          this.showCandidate = true;
          this.tabType = 'contactTab'

          document.getElementById("candidate-slider").style.width = "55%";
          document.getElementById("candidate-slider").style.right = "0";
          document.getElementById("overlay").style.display = "block";
          const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
        });
      }
    });
  }

  closeNav() {
    this.showCandidate = false;
    document.getElementById("candidate-slider").style.width = "0";
    document.getElementById("overlay").style.display = "none";
    document.getElementById("candidate-slider").style.right = "-50px";
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
  }

  sanitizeInput(value: string): string {
    return value.replace(/<[^>]*>/g, '');
  }

}

